import React, { useState } from 'react';
import { Star, Quote } from 'lucide-react';

const Testimonials = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const testimonials = [
    {
      id: 1,
      name: "Dr. Sarah Mitchell",
      role: "Fitness Professional",
      avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop",
      rating: 5,
      text: "BIO-PEPTIDE Semaglutide has been a game-changer for my clients. The quality is exceptional and the results speak for themselves. Highly recommend!",
      location: "Los Angeles, USA"
    },
    {
      id: 2,
      name: "Marcus Chen",
      role: "Professional Athlete",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop",
      rating: 5,
      text: "I've tried many peptide products, but BIO-PEPTIDE rHGH stands out. The authenticity verification gives me peace of mind. Outstanding product!",
      location: "Singapore"
    },
    {
      id: 3,
      name: "Emma Rodriguez",
      role: "Wellness Coach",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop",
      rating: 5,
      text: "The MT-2 from BIO-PEPTIDE exceeded my expectations. Fast shipping, genuine product, and amazing customer service. Will definitely order again!",
      location: "Madrid, Spain"
    },
    {
      id: 4,
      name: "James Thompson",
      role: "Bodybuilding Coach",
      avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop",
      rating: 5,
      text: "After 8 years in the industry, I can confidently say BIO-PEPTIDE offers the best quality peptides. The validation system is brilliant!",
      location: "London, UK"
    },
    {
      id: 5,
      name: "Sophia Anderson",
      role: "Nutritionist",
      avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop",
      rating: 5,
      text: "BIO-PEPTIDE Tirzepatide has helped many of my clients achieve their weight management goals safely. Trustworthy and effective!",
      location: "Sydney, Australia"
    },
    {
      id: 6,
      name: "David Park",
      role: "Personal Trainer",
      avatar: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop",
      rating: 5,
      text: "The BPC-157 has been fantastic for recovery. Premium quality, fast delivery, and the validation feature ensures authenticity. 10/10!",
      location: "Seoul, South Korea"
    }
  ];

  return (
    <section id="testimonials" className="py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-white via-blue-50 to-white relative overflow-hidden">
      {/* Animated background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-20 -left-20 w-96 h-96 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-float"></div>
        <div className="absolute bottom-20 -right-20 w-96 h-96 bg-sky-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-float-delayed"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl sm:text-6xl font-bold text-blue-900 mb-6">
            What Our Customers Say
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-sky-400 to-blue-900 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Real reviews from satisfied customers worldwide
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              className={`group relative bg-white rounded-3xl p-8 border-2 shadow-lg transition-all duration-500 transform ${
                hoveredIndex === index
                  ? 'border-blue-500 shadow-2xl scale-105 -rotate-1'
                  : 'border-blue-100 hover:shadow-xl'
              }`}
              style={{
                transformStyle: 'preserve-3d',
                perspective: '1000px'
              }}
            >
              {/* Quote icon decoration */}
              <div className={`absolute top-6 right-6 transition-all duration-500 ${
                hoveredIndex === index ? 'scale-125 rotate-12' : 'scale-100'
              }`}>
                <Quote className="w-10 h-10 text-blue-200" />
              </div>

              {/* Avatar and Info */}
              <div className="flex items-center gap-4 mb-6 relative z-10">
                <div className={`relative transition-transform duration-500 ${
                  hoveredIndex === index ? 'scale-110' : 'scale-100'
                }`}>
                  <div className="w-16 h-16 rounded-full overflow-hidden border-4 border-blue-100 shadow-md">
                    <img
                      src={testimonial.avatar}
                      alt={testimonial.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  {/* Online indicator */}
                  <div className="absolute bottom-0 right-0 w-4 h-4 bg-green-500 rounded-full border-2 border-white"></div>
                </div>
                <div>
                  <h3 className="font-bold text-blue-900 text-lg">{testimonial.name}</h3>
                  <p className="text-sm text-gray-600">{testimonial.role}</p>
                  <p className="text-xs text-gray-500 mt-1">{testimonial.location}</p>
                </div>
              </div>

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className={`w-5 h-5 fill-yellow-400 text-yellow-400 transition-all duration-300 ${
                      hoveredIndex === index ? 'animate-bounce' : ''
                    }`}
                    style={{
                      animationDelay: `${i * 0.1}s`
                    }}
                  />
                ))}
              </div>

              {/* Review Text */}
              <p className="text-gray-700 leading-relaxed relative z-10">
                "{testimonial.text}"
              </p>

              {/* Verified badge */}
              <div className="mt-6 inline-flex items-center gap-2 px-3 py-1 bg-green-50 border border-green-200 rounded-full">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="text-xs font-medium text-green-700">Verified Customer</span>
              </div>

              {/* Hover gradient overlay */}
              <div className={`absolute inset-0 bg-gradient-to-br from-blue-50 to-sky-50 rounded-3xl transition-opacity duration-500 -z-10 ${
                hoveredIndex === index ? 'opacity-50' : 'opacity-0'
              }`}></div>
            </div>
          ))}
        </div>

        {/* Trust badge */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-blue-900 to-blue-800 rounded-full text-white shadow-xl">
            <div className="flex -space-x-2">
              {testimonials.slice(0, 4).map((t, i) => (
                <img
                  key={i}
                  src={t.avatar}
                  alt=""
                  className="w-10 h-10 rounded-full border-2 border-white"
                />
              ))}
            </div>
            <div className="text-left">
              <p className="font-bold text-lg">10,000+ Happy Customers</p>
              <p className="text-sm text-blue-200">Join thousands of satisfied users worldwide</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
